<template>
  <div v-if="activeStepProvider" class="flex items-center space-x-2">
    <img
      :src="getImageForService(activeStepProvider.id) || undefined"
      :alt="activeStepProvider.name || ''"
      class="h-5 w-5"
      loading="lazy"
    />
    <lf-heading3>{{ activeStepProvider.name }}</lf-heading3>
  </div>
</template>

<script setup lang="ts">
import { getImageForService } from "@/helpers/services";
import { useDataOrchestration } from "@/hooks/orchestration";

import LfHeading3 from "@/components/ui/text/LfHeading3.vue";

const { activeStepProvider } = useDataOrchestration();
</script>
